import { render, staticRenderFns } from "./table-row-action-dropdown.vue?vue&type=template&id=2add889b"
import script from "./table-row-action-dropdown.vue?vue&type=script&lang=js"
export * from "./table-row-action-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2add889b')) {
      api.createRecord('2add889b', component.options)
    } else {
      api.reload('2add889b', component.options)
    }
    module.hot.accept("./table-row-action-dropdown.vue?vue&type=template&id=2add889b", function () {
      api.rerender('2add889b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/table-row-action-dropdown.vue"
export default component.exports